import { createSlice } from '@reduxjs/toolkit';

import { getNumberOfProductsViewed } from 'src/utils';
import { loadPageOfProducts, updateFilters } from '../products/thunks';

export interface AccessibilityState {
  statusMessage: string;
}

export const initialState: AccessibilityState = {
  statusMessage: '',
};

export const { reducer, actions } = createSlice({
  name: 'accessibility',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadPageOfProducts.fulfilled, (state, { payload }) => {
        const numberOfProductsViewed = getNumberOfProductsViewed(
          payload.productsReturnedCount,
          payload.totalProducts,
          payload.totalPages,
          payload.currentPage,
        );

        state.statusMessage = `Products ${numberOfProductsViewed} to ${payload.totalProducts} loaded`;
      })
      .addCase(loadPageOfProducts.pending, (state) => {
        state.statusMessage = 'Loading more products';
      })
      .addCase(loadPageOfProducts.rejected, (state) => {
        state.statusMessage = 'There was a problem loading more products';
      })
      .addCase(updateFilters.fulfilled, (state) => {
        state.statusMessage = `Products loaded`;
      })
      .addCase(updateFilters.pending, (state) => {
        state.statusMessage = 'Loading products';
      })
      .addCase(updateFilters.rejected, (state) => {
        state.statusMessage = 'There was a problem loading products';
      });
  },
});
